import { Button, Card } from 'antd';
import { useEffect, useState } from 'react';
import DetailsPro from '../components/DetailsPro';
import '../../../../styles/pages/seller/_sellers.scss';
import ShipmentMethodCanEdit from '@root/modules/Warehouse/Inquiry/components/shipping/ShipmentMethodCanEdit';
import ShippingPlant from '@root/modules/Warehouse/Inquiry/components/shipping/ShippingPlant';
import CheckPoint from '@root/modules/Warehouse/Shared/Common/CheckPoint';
import { useParams } from 'react-router-dom';
import forwardingService from '../../services';
const DetailedInfo = () => {
  const [quotation, setQuotation] = useState<any>();
  const [seller, setSeller] = useState<any>();
  const { id } = useParams<{ id: string }>();
  const fetchData = async () => {
    const res = await forwardingService.getInboundDetail(id);
    setQuotation(res?.quotation);
    setSeller(res?.seller);
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div className="shipping-detail">
      <div className="admin-container">
        <Card
          bordered={false}
          className="admin-card btnImport"
          style={{
            minHeight: '80vh',
            background: 'none'
          }}
        >
          <div
            className=""
            style={{
              backgroundColor: 'white',
              padding: '20px 10px',
              borderRadius: '6px'
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',

                background: 'white',
                borderBottom: '1px solid #d9d9d9'
              }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '0 10px 30px',
                  background: 'white'
                }}
              >
                <p
                  style={{
                    marginBottom: '0px',
                    fontWeight: 'bold',
                    fontSize: '15px'
                  }}
                >
                  {seller?.companyName}
                </p>
                <p
                  style={{
                    marginBottom: '0px',
                    marginLeft: '10px',
                    color: '#747274'
                  }}
                >
                  {seller?.email}
                </p>
              </div>
              <div className="header-detail" style={{ padding: 0 }}>
                {/* <div className="wrapShow">
              <div className="detail --center">
                <Text keyboard disabled>
                  {productImportQuotation.warehouse?.name}
                </Text>
              </div>
              <div className="detail">
                <Text keyboard disabled>
                  {productImportQuotation.warehouse?.detailAddress}
                </Text>
              </div>
            </div> */}
                <Button>{quotation?.progressStatus}</Button>
              </div>
            </div>

            <DetailsPro {...quotation?.products?.[0]} />

            <div style={{ display: 'flex', marginTop: '15px', gap: '10px' }}>
              <ShipmentMethodCanEdit
                shipmentMethod={quotation?.shipmentMethod}
              />
              <ShippingPlant
                shippingPlanEta={quotation?.shippingPlanEta}
                shippingPlanEtd={quotation?.shippingPlanEtd}
              />
              <CheckPoint data={{ checkPoint: quotation?.comment }} />
            </div>

            {/* <div className="importBtn">
              <div className="button-container">
                <Button
                  style={{
                    borderRadius: '9px',
                    backgroundColor: '#D98282',
                    color: 'white'
                  }}
                  type="default"
                >
                  Reject
                </Button>
              </div>
              <div className="button-container">
                <Button
                  style={{ borderRadius: '9px', backgroundColor: '#629C53' }}
                  className="renueProduct"
                >
                  Approve
                </Button>
              </div>
            </div> */}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DetailedInfo;
